import { render, staticRenderFns } from "./FileProperties.vue?vue&type=template&id=bd4bcf70&"
import script from "./FileProperties.vue?vue&type=script&lang=js&"
export * from "./FileProperties.vue?vue&type=script&lang=js&"
import style0 from "./FileProperties.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports